<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <dl class="row mb-0 font-size-14">
                      <!--
                        <dt class="col-sm-4">ID</dt>
                        <dd class="col-sm-8">: {{data.partida_id}}</dd>

                        <dt class="col-sm-4">Partida</dt>
                        <dd class="col-sm-8">: {{data.partida}}</dd>
                      -->
                    </dl>
                </div>

            </div>

            <div class="row font-size-12">
                <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th class="col-md-1" >Fecha</th>
                        <th>Partida</th>
                        <th>UM</th>
                        <th>Cantidad</th>
                        <th >Costo unitario</th>
                        <th>Parcial</th>
                        <th>Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(data,index) in data.partidas" >
                        <tr  v-bind:key="index" :class="{'table-light': index % 2 === 0 }">
                          <td>{{ data.avance_id }}</td>
                          <td>{{data.fecha}}</td>
                          <td>{{data.partida}}</td>
                          <td>{{data.unidad_medida}}</td>
                          <td>{{data.cantidad_corregida}}</td>
                          <td class="text-right">{{data.costo_unitario}}</td>
                          <td>{{data.subtotal_corregido}}</td>
                          <td>{{data.estado_str}}</td>

                        </tr>
                        <tr v-bind:key="index.toString()+'F'" v-if="parseInt(data.estado)===3"  :class="{'table-light': index % 2 === 0 }">
                          <td></td>
                          <td></td>
                          <td class="text-right">Observacion:</td>

                          <td colspan="7">
                            {{data.observacion}}
                          </td>
                        </tr>
                        <tr class="border-bottom"  v-bind:key="index.toString()+'G'"></tr>
                      </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "revisar-avance-partidas-info",
        components: {

        },
        methods:{


        },
        props: {
            data:{
                type:Object
            }
        },
        data() {
            return {
                server:process.env.VUE_APP_BACKEND,
            }
        }
    }
</script>

<style scoped>

</style>